module.exports = __webpack_public_path__ + "img/login-sanpedroysanpablo.e47bb8a8.svg";